// extracted by mini-css-extract-plugin
export var ctabuttoncontainer = "videoLift-module--ctabuttoncontainer--L1ZjI";
export var ctabuttoncontainerflex = "videoLift-module--ctabuttoncontainerflex--dZVwu";
export var videoLift = "videoLift-module--videoLift--yZOac";
export var videoLiftTextContainer = "videoLift-module--videoLiftTextContainer--kqhY+";
export var videoPlayer = "videoLift-module--videoPlayer--FjdWq";